export default "__VITE_ASSET__CnArlqC0__"